import { AxiosRequestConfig } from 'axios';
import { mapToData } from 'src/common/http/mapToData';
import { mapToErrors } from 'src/common/http/mapToErrors';

import instance from '../../../common/http/axiosInstance';
import {
  ExportProjectUsersDTO,
  ProjectUserDetail,
  ProjectUsersResponse,
  ProjectUsersTotalsResponse,
  SearchProjectUsersDTO,
  UserAttributionsRequestParams,
  UserAttributionsResponse,
  UserDetailRequestParams,
  UserMetricsBreakdownRequestParams,
  UserMetricsBreakdownResponse,
} from './dtos';

const requests = {
  get: async <T>(url: string, config?: AxiosRequestConfig): Promise<T> =>
    instance
      .get(url, config)
      .then(mapToData)
      .catch((err) => {
        if (err.response?.status === 404) {
          return null;
        }

        return mapToErrors(err);
      }),
  post: async <T, K>(url: string, body: T): Promise<K> => instance.post(url, body).then(mapToData).catch(mapToErrors),
};

export const projectUsersService = {
  getProjectUsers: async (projectId: string, searchParams: SearchProjectUsersDTO): Promise<ProjectUsersResponse> =>
    requests.get<ProjectUsersResponse>(`projects/${projectId}/users`, { params: searchParams }),
  getProjectUsersTotals: async (projectId: string): Promise<ProjectUsersTotalsResponse> =>
    requests.get<ProjectUsersTotalsResponse>(`projects/${projectId}/users/totals`),
  exportCSV: async (projectId: string, dto: ExportProjectUsersDTO): Promise<void> =>
    requests.post<ExportProjectUsersDTO, void>(`projects/${projectId}/users/export`, dto),

  getProjectUserDetail: async (projectId: string, params: UserDetailRequestParams): Promise<ProjectUserDetail | null> =>
    requests.get<ProjectUserDetail>(`projects/${projectId}/users/detail`, { params }),

  getProjectUserMetricsBreakdown: async (
    projectId: string,
    params: UserMetricsBreakdownRequestParams,
  ): Promise<UserMetricsBreakdownResponse | null> =>
    requests.get<UserMetricsBreakdownResponse>(`projects/${projectId}/users/metrics-breakdown`, { params }),

  getProjectUserAttributions: async (
    projectId: string,
    params: UserAttributionsRequestParams,
  ): Promise<UserAttributionsResponse | null> =>
    requests.get<UserAttributionsResponse>(`projects/${projectId}/users/attributions`, { params }),
};
